
import Vue from 'vue'
import ModDiffView from '@/components/DiffView/ModDiffView.vue'
import PSDiffView from '@/components/DiffView/PSDiffView.vue'
import ContDiffView from '@/components/DiffView/ContDiffView.vue'
import DatasetDiffView from '@/components/DiffView/DatasetDiffView.vue'
import GlobalService from '@/services/GlobalService'
import SelectConfigDialog from '../MenuBar/SelectConfigDialog.vue'
import { ContainersDiff, DatasetsDiff, PSetsDiff, StreamsDiff, ParamChange, CfgDiff , PrescaleTblDiff} from '@/types'
const _ = require('lodash')
export default Vue.extend({
  name: 'CfgDiffView',
   data() {
    return {
      tab: null,    
      loading : false,
      diff : undefined as undefined | CfgDiff, 
      selectConfigVisible : false,
      selectConfigOutLoc : "" as string,
      toCfgSelection : "" as string,
      fromCfgSelection : "" as string,
      error : undefined as undefined | string, 
      hidePathVersionChangeOnly : false as boolean,
      hideRedundantDiffs : false as boolean
       
    };
  },
  components :{
    ModDiffView : ModDiffView,
    PSDiffView : PSDiffView,
    ContDiffView : ContDiffView,
    DatasetDiffView : DatasetDiffView,
    SelectConfigDialog : SelectConfigDialog
  },
  methods: {
    async loadDiff(){
      if(this.to_cfg==undefined || this.to_cfg=='' ||
        this.from_cfg==undefined || this.from_cfg==''){
        return
      }
      this.error = undefined 
      this.loading=true       
      return GlobalService.getDiff(this.to_cfg,this.from_cfg)
        .then((response) => {          
          if(response.data.status=="SUCCESS"){
            this.diff = response.data.result.diff
          }else{
            this.error = response.data.result
          }          
          this.loading=false
        }).catch((error ) => {
          this.loading=false
          console.log(error)
          this.error = error
        })
    },
    setDiff(){
      if(this.to_cfg!=this.toCfgSelection || this.from_cfg!=this.fromCfgSelection){
        this.diff = undefined
        this.$router.push({path: "diff", query: {to_cfg: this.toCfgSelection, from_cfg : this.fromCfgSelection }})
      }
    },
    selectConfigName(outLoc : string){
      this.selectConfigVisible = true
      this.selectConfigOutLoc = outLoc      
    },
    diffCount(diff : PSetsDiff | DatasetsDiff | ContainersDiff | StreamsDiff){
      return diff.added.length + diff.removed.length + diff.changed.length
    },
    psDiffMsg(diff : PrescaleTblDiff){
      if(diff.colls_added.length>0 || diff.colls_removed.length>0 || diff.path_ps_changes.length>0){
        return "(*)"
      }else{
        return "(0)"
      }
    },
    psetIgnoreChange(change : ParamChange) {
      if(change.name.startsWith("datasets.") || change.name.endsWith(".triggerConditions") || change.name.startsWith("streams.") || change.name.startsWith("PrescaleService.prescaleTable")){
        return true
      }else{
        return false
      }
    },
    swapDiff() {
      const tmp = this.toCfgSelection
      this.toCfgSelection = this.fromCfgSelection
      this.fromCfgSelection = tmp
      this.setDiff()
    }
  },
  computed: {
    diffFiltered() : CfgDiff | undefined{
      if(this.diff==undefined) return undefined
      else {
        const val = _.cloneDeep(this.diff)
        if (this.hidePathVersionChangeOnly){
          val.pathdiffs.changed = this.diff.pathdiffs.changed.filter(x=> !_.isEqual(x.from_entries,x.to_entries))
        }
        if (this.hideRedundantDiffs){
          val.psetdiffs.changed = this.diff.psetdiffs.changed.filter(x=> !this.psetIgnoreChange(x))
        }
        return val
      }
    },
    combinedCfgs() : Array<string>{
      return [this.to_cfg,this.from_cfg]
    }

  },
  props:{
    to_cfg : String,
    from_cfg : String
  },
  created(){
    if(this.to_cfg!='' && this.from_cfg!='') {
      this.toCfgSelection = this.to_cfg
      this.fromCfgSelection = this.from_cfg
      this.loadDiff()
    }
  },
  watch: {
    combinedCfgs : function() {      
      this.toCfgSelection = this.to_cfg
      this.fromCfgSelection = this.from_cfg
      this.loadDiff()
    },
    
  }
})
